import React from "react";
import "./aboutCard.scss";

const AboutCard = ({ icon, title, desc }) => {
  return (
    <div class="aboutCard__container">
      <div class="aboutCard__box">
        <div className="aboutCard__icon">{icon}</div>

        <div className="aboutCard__Content">
          <span className="aboutCard__title">{title}</span>
          <span className="aboutCard__desc">{desc}</span>
        </div>
      </div>
    </div>
  );
};

export default AboutCard;
